import {EuiBottomBar, EuiText} from "@elastic/eui";

export const Footer: React.FC = () => {
    return (
        <EuiBottomBar position="sticky" bottom={10} style={{backgroundColor: "rgb(16 49 72)"}}>
        </EuiBottomBar>
    )
}